import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	Output
} from '@angular/core';
import { InvoicesDataProvider } from '../../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';
import { MessageService } from '../../../../../../shared/services/helpers/message-service/message.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'copy-invoice-to-qb-or-xero',
	template: require('./copy-invoice-to-qb-or-xero.modal.html'),
	styles: [require('./copy-invoice-to-qb-or-xero.modal.scss')]
})
export class CopyInvoiceToQuickBooksOrXeroModal implements OnDestroy {
	@Input('jobId') jobId: number;
	@Input('integrationSystemName') integrationSystemName: string;
	@Input('invoiceName') invoiceName: string;
	@Output('updateInvoices')
	updateInvoices: EventEmitter<boolean> = new EventEmitter<boolean>();

	btnDisabled = false;
	copyInvoiceToOtherSystemSpinner = false;
	importInvoicesSpinner = false;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private invoiceDataService: InvoicesDataProvider,
		private messageService: MessageService,
		private activeModal: NgbActiveModal
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	integrateInvoiceWithOtherSystem(integrateInvoiceWithOtherSystem: boolean) {
		this.btnDisabled = true;

		integrateInvoiceWithOtherSystem
			? (this.copyInvoiceToOtherSystemSpinner = true)
			: (this.importInvoicesSpinner = true);
		this.invoiceDataService
			.importInvoicesPicTime(this.jobId, integrateInvoiceWithOtherSystem)
			.pipe(
				takeUntil(this.unsubscribe),
				finalize(() => this.removeSpinnersAndDisabled())
			)
			.subscribe(
				() => {
					this.messageService.showToaster('s_6', 'picTime');
					this.updateInvoices.emit(true);
					this.onDismiss();
				},
				error => this.messageService.handleError(error)
			);
	}

	removeSpinnersAndDisabled(): void {
		this.btnDisabled = false;
		this.copyInvoiceToOtherSystemSpinner = false;
		this.importInvoicesSpinner = false;
	}

	onDismiss() {
		this.activeModal.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/invoices/modals/copy-invoice-to-qb-or-xero/copy-invoice-to-qb-or-xero.modal.ts